import Logo from "../../assets/images/BX-LOGO.svg";
import {Link, } from "react-router-dom";
import React from 'react';
import {useLocation} from "react-router-dom";

function PasswordResetEmailSentPage() {

    const location = useLocation();
    const { email } = location.state || {};

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                    </div>
                                    <div className="mt-3 text-center">
                                        <h4>Password Reset Email Sent !</h4>
                                        <p className="text-muted mt-2">We have sent an email to <span
                                            className="font-weight-medium">{email} </span>
                                            to reset your password.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p className="text-muted">
                                        Go back to login?
                                        <Link
                                            to="/login"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                            Log In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordResetEmailSentPage;